<template>
  <div>

    <div class="row">
      <div class="col-md-12">

        <KTPortlet
            v-bind="{
            }"
            v-bind:class="{ 'kt-spinner-f': loading }"
        >
          <template v-slot:title>
            <h4 class="">Credenziali ESTRA SF</h4>
          </template>
          <template v-slot:body>

            <b-alert v-if="!available" show variant="warning">
              Questa funzionalità non è disponibile per la tua organizzazione.
            </b-alert>

            <template v-if="available">
              <p class="text-muted">
                Inserisci le credenziali del portale agenzie ESTRA
                (<a href="https://agenzie.aliaestra.it" target="_blank" rel="noopener">agenzie.aliaestra.it</a>).
                Vengono verificate con una login reale al salvataggio e usate
                per l'invio dei contratti ESTRA.<br>
                <strong>Nota:</strong> la prima volta è necessario effettuare
                la procedura di login direttamente dal
                <a href="https://agenzie.aliaestra.it" target="_blank" rel="noopener">sito del portale</a>
                (attivazione account e cambio password iniziale), altrimenti la
                verifica qui fallirà.
              </p>

              <b-alert v-if="status === 'valid'" show variant="success">
                Credenziali configurate e valide per l'utente <strong>{{ currentUsername }}</strong>.
              </b-alert>
              <b-alert v-if="status === 'invalid'" show variant="danger">
                Le credenziali salvate<span v-if="currentUsername"> per <strong>{{ currentUsername }}</strong></span>
                non risultano più valide (password errata o scaduta).
                Verifica l'accesso su
                <a href="https://agenzie.aliaestra.it" target="_blank" rel="noopener">agenzie.aliaestra.it</a>
                e aggiornale qui sotto.
              </b-alert>
              <b-alert v-if="status === 'missing'" show variant="warning">
                Nessuna credenziale ESTRA SF configurata. Inseriscile qui sotto.
              </b-alert>

              <b-form @submit.prevent="onSubmit" @reset="onReset">
                <b-form-group
                    label-cols="4"
                    label-cols-lg="2"
                    label="Username"
                    label-for="estrasf-username"
                >
                  <b-form-input
                      id="estrasf-username"
                      v-model="form.username"
                      type="text"
                      required
                      placeholder="utente@dominio.it"
                  ></b-form-input>
                </b-form-group>
                <b-form-group
                    label-cols="4"
                    label-cols-lg="2"
                    label="Password"
                    label-for="estrasf-password"
                >
                  <b-form-input
                      id="estrasf-password"
                      v-model="form.password"
                      type="password"
                      required
                      placeholder="Password"
                  ></b-form-input>
                </b-form-group>

                <b-button class="pull-right" type="submit" variant="primary" :disabled="saving">
                  <span v-if="saving"><i class="fa fa-spinner fa-spin"></i> Verifica in corso…</span>
                  <span v-else>Verifica e salva</span>
                </b-button>
                <b-button type="reset" variant="danger" :disabled="saving">Annulla</b-button>
              </b-form>
            </template>

          </template>
        </KTPortlet>
      </div>
    </div>
  </div>
</template>

<script>
import {SET_BREADCRUMB} from "@/store/breadcrumbs.module";
import KTPortlet from "@/views/partials/content/Portlet.vue";
import JwtService from "@/common/jwt.service";
import Vue from "vue";

function estrasfServiceUrl() {
  const url = (window.__env && window.__env.estrasfServiceUrl) || 'https://estra-sf.dock.fastsign.it';
  return url.replace(/\/+$/, '');
}

function estrasfSaveWebhookUrl() {
  return (window.__env && window.__env.estrasfSaveWebhookUrl)
      || 'https://n8n.dock.fastsign.it/webhook/5fc6a773-5636-4204-b1f4-13a1920512d2';
}

function estrasfGetWebhookUrl() {
  return (window.__env && window.__env.estrasfGetWebhookUrl)
      || 'https://n8n.dock.fastsign.it/webhook/e21e05e0-2543-4fdc-a259-518005e89ada';
}

export default {
  data() {
    return {
      loading: false,
      saving: false,
      // 'unknown' | 'missing' | 'invalid' | 'valid'
      status: 'unknown',
      currentUsername: null,
      form: {
        username: '',
        password: '',
      },
    };
  },
  components: {
    KTPortlet
  },
  computed: {
    available() {
      return !!this.$store.getters.currentUser.estrasf_available;
    },
    me() {
      return this.$store.getters.currentUser;
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: "Impostazioni"},
      {title: "Credenziali ESTRA SF"}
    ]);
    if (this.available) {
      this.reload();
    }
  },
  methods: {
    checkCredentials(payload) {
      return fetch(estrasfServiceUrl() + '/credentials/check', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(payload),
      }).then(r => r.json());
    },
    prefill() {
      // saved creds for the logged-in user (n8n verifies the JWT, user_id
      // comes from the token payload server-side)
      fetch(estrasfGetWebhookUrl(), {
        headers: {'Authorization': 'Bearer ' + JwtService.getToken()},
      })
          .then(r => r.ok ? r.json() : null)
          .then(data => {
            const d = Array.isArray(data) ? data[0] : data;
            if (!d) return;
            if (d.estraSFUser) this.form.username = d.estraSFUser;
            if (d.estraSFPassword) this.form.password = d.estraSFPassword;
          })
          .catch(() => {});
    },
    reload() {
      this.loading = true;
      this.prefill();
      this.checkCredentials({userId: this.me.id, userEmail: this.me.email})
          .then((data) => {
            this.loading = false;
            if (!data || !data.ok) {
              this.status = 'unknown'; // lookup infra down — don't scare the user
              return;
            }
            this.currentUsername = data.username || null;
            if (data.username && !this.form.username) {
              this.form.username = data.username;
            }
            this.status = !data.found ? 'missing' : (data.valid ? 'valid' : 'invalid');
          })
          .catch(() => {
            this.loading = false;
            this.status = 'unknown';
          });
    },
    onSubmit() {
      this.saving = true;
      const username = this.form.username.trim();
      const password = this.form.password;

      // 1. real SF login with the new creds — refuse to save broken ones
      this.checkCredentials({username, password})
          .then((check) => {
            if (!check || !check.ok) {
              throw new Error('Servizio ESTRA SF non raggiungibile, riprovare più tardi');
            }
            if (!check.valid) {
              console.warn('ESTRA SF login check failed:', check.error);
              throw new Error('Login al portale ESTRA fallita: controlla utente e password. ' +
                  'Se è il primo accesso, completa prima la procedura di login su agenzie.aliaestra.it');
            }
            // 2. persist via the n8n webhook (writes user_attributes). The
            // fastsign JWT is sent so n8n can verify it (HS256, JWT_SECRET)
            // and take user_id/email from the token payload (sub/email)
            // instead of trusting the body.
            return fetch(estrasfSaveWebhookUrl(), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + JwtService.getToken(),
              },
              body: JSON.stringify({
                id: this.me.id,
                email: this.me.email,
                estraSFUser: username,
                estraSFPassword: password,
              }),
            });
          })
          .then((r) => {
            if (!r.ok) {
              throw new Error('Salvataggio credenziali fallito (HTTP ' + r.status + ')');
            }
            // 3. drop the service's lookup cache so the new creds are live now
            return this.checkCredentials({userId: this.me.id, userEmail: this.me.email, fresh: true});
          })
          .then(() => {
            this.saving = false;
            this.form.password = '';
            Vue.customNotifySuccess('Credenziali ESTRA SF verificate e salvate');
            this.reload();
          })
          .catch((e) => {
            this.saving = false;
            Vue.customNotifyError('Errore', e && e.message ? e.message : 'Si prega di riprovare');
          });
    },
    onReset() {
      this.$router.go(-1);
    },
  }
};
</script>
